module.exports = __webpack_public_path__ + "media/images/webpage/errors/bg-503-bb7e0a6fe94b9ff2e1ef95ee94e18896.webp";